/**
 * Types of map items
 */
export enum MapItems {
    DEVICE = "device",
    CLUSTER = "cluster",
    OTHER = "other",
}

/**
 * Possible values of valveType from DeviceTypeConfigurations[deviceType].valveType
 */
export enum ValveType {
    BLOCK = "block",
    MICRO = "micro",
    NONE = "none",
}
